<template>
  <div class="fullscreen-notif position-fixed">
    <button
      v-if="show"
      type="button"
      class="close position-fixed"
      aria-label="Close"
      v-on:click="closeNotification"
    >
      <div class="icon-wrapper">
        <i class="material-icons-round">close</i>
      </div>
    </button>
    <div class="d-flex min-height align-items-center">
      <div class="container-fluid px-4 mx-2">
        <div class="text-center pb-1">
          <svg-icon icon="success" />
          <div v-html="text"></div>
        </div>
        <router-link
          v-if="link"
          :to="link"
          class="btn btn-block"
          v-bind:class="[button_style ? button_style : 'btn-secondary']"
          >{{ button }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    button: String,
    button_style: String,
    link: Object,
    show: Boolean
  },
  methods: {
    async closeNotification() {
      this.$emit("input", null); // fullscreen_notif
    }
  }
};
</script>

<style scoped>
.fullscreen-notif /deep/.svg-container {
  margin-bottom: 40px;
}

.fullscreen-notif /deep/.svg-container svg {
  width: 100%;
  height: 100%;
}
</style>
